export type CartItemTotals = {
  price: number;
  quantity: number;
  cgst_amount?: number;
  sgst_amount?: number;
  igst_amount?: number;
};

export type TotalsResult = {
  subtotal: number;
  tax: number;
  shipping: number;
  discount: number;
  grandTotal: number;
};

// Calculate totals consistently across pages
export function calculateOrderTotals(
  items: CartItemTotals[],
  opts?: { intraState?: boolean; shipping?: number; discount?: number }
): TotalsResult {
  const intraState = opts?.intraState ?? true;
  const shipping = Number(opts?.shipping ?? 0);
  const discount = Number(opts?.discount ?? 0);

  const subtotal = items.reduce((sum, item) => {
    const line = Number(item.price || 0) * Number(item.quantity || 0);
    return sum + line;
  }, 0);

  const tax = items.reduce((sum, item) => {
    const cgst = Number(item.cgst_amount || 0);
    const sgst = Number(item.sgst_amount || 0);
    const igst = Number(item.igst_amount || 0);
    return sum + (intraState ? cgst + sgst : igst);
  }, 0);

  const grandTotal = subtotal + tax + shipping - discount;

  return { subtotal, tax, shipping, discount, grandTotal };
}


